/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-south-1",
    "aws_cognito_identity_pool_id": "ap-south-1:c205a26e-c868-4618-b8d9-6ca68bf868f9",
    "aws_cognito_region": "ap-south-1",
    "aws_user_pools_id": "ap-south-1_JgZyUeJXS",
    "aws_user_pools_web_client_id": "64gl237p12iidajkaflt97h0gl",
    "oauth": {}
};


export default awsmobile;

